// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedArticlesList_container__8wU_T","heading":"RelatedArticlesList_heading__UgA2D","articles":"RelatedArticlesList_articles__OijQ0"};